import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, AvatarGroup, Box, Button, Flex, MenuItem, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, mode, Text, useColorMode, useDisclosure } from '@abb/uikit';
import { ChevronRight } from '@abb/uikit/icons/outline/arrow';
import { useDependencies, useSetToken } from 'hooks';
import React from 'react';
import { useTranslation } from 'react-i18next';
export const CustomersModal = (param)=>{
    let { data } = param;
    var _data_filter, _data_filter1;
    const { t } = useTranslation('common');
    const { colorMode } = useColorMode();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { userService } = useDependencies();
    const { trigger } = useSetToken();
    const userData = userService === null || userService === void 0 ? void 0 : userService.getUserData;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(MenuItem, {
                _hover: {
                    bg: mode('#FAFAFA', '#292B2E')({
                        colorMode
                    })
                },
                p: "12px",
                borderTopRadius: "12px",
                children: /*#__PURE__*/ _jsxs(Flex, {
                    w: "100%",
                    alignItems: "center",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ _jsx(AvatarGroup, {
                            sx: {
                                '& span:first-of-type': {
                                    bg: 'transparent',
                                    ml: '0px'
                                }
                            },
                            size: "sm",
                            max: 3,
                            children: data === null || data === void 0 ? void 0 : (_data_filter = data.filter((item)=>item.name !== (userData === null || userData === void 0 ? void 0 : userData.customers[0].name))) === null || _data_filter === void 0 ? void 0 : _data_filter.map((item)=>/*#__PURE__*/ _jsx(Avatar, {
                                    borderColor: "white",
                                    size: "sm",
                                    name: item.name
                                }, item.cif))
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: onOpen,
                            bg: mode('#0A0B0D0A', '#484A4F')({
                                colorMode
                            }),
                            variant: "gray",
                            size: "sm",
                            borderRadius: "12px",
                            children: t('user_settings.accounts')
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Modal, {
                isOpen: isOpen,
                onClose: onClose,
                children: [
                    /*#__PURE__*/ _jsx(ModalOverlay, {}),
                    /*#__PURE__*/ _jsxs(ModalContent, {
                        borderRadius: "24px",
                        children: [
                            /*#__PURE__*/ _jsx(ModalCloseButton, {
                                border: "1px",
                                borderColor: mode('#F0F0F0', '#0A0B0D')({
                                    colorMode
                                }),
                                borderRadius: "99px"
                            }),
                            /*#__PURE__*/ _jsx(ModalHeader, {
                                children: t('user_settings.switch_account')
                            }),
                            /*#__PURE__*/ _jsx(ModalBody, {
                                children: /*#__PURE__*/ _jsx(Box, {
                                    width: "100%",
                                    border: "1px solid",
                                    borderColor: mode('#F0F0F0', '#0A0B0D')({
                                        colorMode
                                    }),
                                    borderRadius: "16px",
                                    mb: "24px",
                                    maxHeight: "400px",
                                    overflow: "auto",
                                    children: data === null || data === void 0 ? void 0 : (_data_filter1 = data.filter((item)=>item.name !== (userData === null || userData === void 0 ? void 0 : userData.customers[0].name))) === null || _data_filter1 === void 0 ? void 0 : _data_filter1.map((item)=>/*#__PURE__*/ _jsxs(Flex, {
                                            cursor: "pointer",
                                            onClick: ()=>trigger({
                                                    cif: item.cif
                                                }),
                                            p: 4,
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            children: [
                                                /*#__PURE__*/ _jsxs(Flex, {
                                                    gap: 3,
                                                    alignItems: "center",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Avatar, {
                                                            borderColor: "white",
                                                            size: "sm",
                                                            name: item.name
                                                        }),
                                                        /*#__PURE__*/ _jsx(Text, {
                                                            width: "300px",
                                                            textTransform: "none",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            children: item.name
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(ChevronRight, {})
                                            ]
                                        }, item.cif))
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
